module.exports = __webpack_public_path__ + "static/media/ghmc.e6a60b84.png";